var _defs, _circle, _circle2, _circle3, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDynamic = function SvgDynamic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    className: "Dynamic_svg__nc-icon-wrapper"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Dynamic_svg__1690361774251-5988166_nc-loop-gooey-32-filter"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "blur",
    result: "goo",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 19 -9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "goo",
    operator: "atop"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "Dynamic_svg__nc-loop-gooey-32-icon-f",
    filter: "url(#Dynamic_svg__1690361774251-5988166_nc-loop-gooey-32-filter)",
    style: {
      "--animation-duration": "1s"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 16,
    r: 4,
    style: {
      transformOrigin: "5px 16px",
      animation: "dynamic-icon-anim var(--animation-duration) infinite"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 16,
    r: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 16,
    r: 4
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null))));
};
export default SvgDynamic;